class StayAISubscriptions extends HTMLElement {
  static get observedAttributes() {
    return ["data-subscription-widget", "data-subscription-style"];
  }

  constructor() {
    super();

    this.attachShadow({ mode: "open" });

    // Default data if no data is passed
    this.retextionData = {
      retextionAppId: "5859381",
      product: {},
      currentVariant: {},
      sellingPlanGroups: [],
      show_purchase_options: true,
      purchase_type_label: "Purchase Type",
      frequency_heading: "Frequency",
      one_time_purchase_label: "One time",
      subscription_label: "One time",
      default_to_subscription: false,
      default_to_subscription_on_variant_change: false,
      frequencyVisible: true,
      show_subscription_details: true,
      icon_path:
          "<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' ><path fill='currentColor' d='M13.64 2.35C12.19 0.9 10.2 0 7.99 0C3.57 0 0 3.58 0 8C0 12.42 3.57 16 7.99 16C11.72 16 14.83 13.45 15.72 10H13.64C12.82 12.33 10.6 14 7.99 14C4.68 14 1.99 11.31 1.99 8C1.99 4.69 4.68 2 7.99 2C9.65 2 11.13 2.69 12.21 3.78L8.99 7H15.99V0L13.64 2.35Z'></path></svg>",
      subscription_details_box_button_text: "Subscription Details",
      subscription_details_box_title: "How subscriptions work",
      subscription_details_box_content:
          "Products are automatically delivered on your schedule. No obligation, modify or cancel your subscription anytime.",
      requiresPlan: false,
      productFormId: "form[action='/cart/add']",
    };
    this.previousRetextionData = {};
    this.subscriptionWidget = null;
    this.purchaseTypeOneTime = null;
    this.purchaseTypeSubscription = null;
    this.radioOneTime = null;
    this.radioSubscription = null;
    this.subscriptionBox = null;
    this.sellingPlanSelector = null;
    this.selectedPlanValueLabel = null;

    this.shadowRoot.innerHTML = `
      <div class="stay-ai-subscriptions is-visible">
        <span class="purchaseTypeLbl"></span>
        
        <div data-rtx-subscription class="rtx-subscription">
          <div class="widget">
            <div class="wrap-subscription-label">
              <label for="purchaseTypeSubscription" class="purchaseTypeSubscription rtx-purchase-label is-selected">
                <div class="purchase-label">
                  <div class="rtx-purchase-label__inner">
                    <div class="wrap">
                      <span class="input-wrap">
                       <input type="radio" id="purchaseTypeSubscription" name="purchaseType" value="purchaseTypeSubscription" checked />
                       <span class="input-radio"></span>
                      </span>
                      <span class="subscription-label"></span>
                    </div>
                    <span class="subscription-custom-label desktop">free shipping</span>
                    <span class="subscription-savings"></span>
                  </div>
                  <span data-rtx-subscription-price></span>
                </div>
              </label>
            
              <div data-retextion-subscription-box class="rtx-subscription-box">
                <div class="custom-select-wrap">
                  <span class="custom-select-txt">deliver every: 
                     </span>
                  <div class="custom-select">
                    <select class="rtx-subscription-dropdown" name="rtx_selling_plan"></select>
                  </div>
                </div>
              </div>
              
              <span class="subscription-custom-label mobile">free shipping</span>
            </div>
            
            <label for="purchaseTypeOneTime" class="rtx-purchase-label purchaseTypeOneTime">
              <div class="purchase-label">
                <div class="rtx-purchase-label__inner">
                  <div class="wrap">
                    <span class="input-wrap">
                      <input type="radio" id="purchaseTypeOneTime" name="purchaseType" value="purchaseTypeOneTime"  />
                      <span class="input-radio"></span>
                    </span>
                    <span class="one-time-purchase-label"></span>
                  </div>
                </div>
                <span data-rtx-onetime-price></span>
              </div>
            </label>
          </div>
          
          <div class="rtx-subscription-details-box" style="display: none">
            <button type="button" class="rtx-modal-button" data-rtx-modal-open>
              <span class="icon-container"></span>
              <span class="subscription-details-button-text"></span>
            </button>
            <div class="rtx-modal" data-rtx-modal>
              <div class="rtx-modal__content">
                <span class="subscription-details-title"></span>
                <p class="subscription-details-content"></p>
              </div>
            </div>
          </div>
        </div>
      </div>      
    `;
  }

  // Called when the data-subscription-widget attribute changes
  attributeChangedCallback(name, oldValue, newValue) {
    if (this.subscriptionBox == null) {
      this.subscriptionWidget = this.shadowRoot.querySelector(
          `.stay-ai-subscriptions`
      );
      this.purchaseTypeOneTime = this.shadowRoot.querySelector(
          '[for="purchaseTypeOneTime"]'
      );
      this.purchaseTypeSubscription = this.shadowRoot.querySelector(
          '[for="purchaseTypeSubscription"]'
      );
      this.radioOneTime = this.shadowRoot.querySelector(
          '[value="purchaseTypeOneTime"]'
      );
      this.radioSubscription = this.shadowRoot.querySelector(
          '[value="purchaseTypeSubscription"]'
      );
      this.subscriptionBox = this.shadowRoot.querySelector(
          "[data-retextion-subscription-box]"
      );
      this.sellingPlanSelector = this.shadowRoot.querySelector(
          ".rtx-subscription-dropdown"
      );
      // this.selectedPlanValueLabel =
      //   this.shadowRoot.querySelector(".select-value");

      this.subscriptionDetailsBox = this.shadowRoot.querySelector(
          ".rtx-subscription-details-box"
      );
    }

    if (name === "data-subscription-widget" && newValue) {
      // Skip processing if value hasn't changed.
      if (
          this.previousRetextionData &&
          JSON.stringify(this.previousRetextionData) === JSON.stringify(newValue)
      )
        return;

      let newData = JSON.parse(newValue);
      this.updateWidgetIfChanged(newData);
      // Initialize event listeners
      this.setupEventListeners();
    }

    // Apply styles if the data-subscription-style attribute changes
    if (name === "data-subscription-style" && newValue) {
      let newStyle = JSON.parse(newValue);
      this.applyStyles(newStyle);
    }
  }

  updateExternalPrice(sellingPlanId) {
    const { currentVariant } = this.retextionData;
    if (!currentVariant) return;

    const hostSection = this.closest('product-info') || document;
    const mainPriceContainer = hostSection.querySelector('.js-main-price-container');
    if (!mainPriceContainer) return;

    const priceRoot = mainPriceContainer.querySelector('.price');
    const regularPriceEl = mainPriceContainer.querySelector('.price__regular .price-item--regular');
    const saleCompareEl = mainPriceContainer.querySelector('.price__sale .price-item--regular');
    const salePriceEl = mainPriceContainer.querySelector('.price__sale .price-item--sale');
    if (!priceRoot) return;

    const variantPrice = currentVariant.price;
    const variantCompareAt = currentVariant.compare_at_price;
    const isSubscriptionSelected = this.isSubscriptionOptionSelected();

    let subscriptionPrice = null;
    if (isSubscriptionSelected && sellingPlanId) {
      const allocation = currentVariant.selling_plan_allocations.find(
          (spa) => spa.selling_plan_id == sellingPlanId
      );
      if (allocation) subscriptionPrice = allocation.per_delivery_price;
    }

    const hasSubscriptionDiscount =
        subscriptionPrice !== null && subscriptionPrice < variantPrice;
    const hasVariantSale =
        variantCompareAt && variantCompareAt > variantPrice;

    if (hasSubscriptionDiscount) {
      priceRoot.classList.add('price--on-sale');
      if (saleCompareEl) saleCompareEl.textContent = this.formatMoneyWithoutTrailingZeros(variantPrice);
      if (salePriceEl) salePriceEl.textContent = this.formatMoneyWithoutTrailingZeros(subscriptionPrice);
    } else if (hasVariantSale) {
      priceRoot.classList.add('price--on-sale');
      if (saleCompareEl) saleCompareEl.textContent = this.formatMoneyWithoutTrailingZeros(variantCompareAt);
      if (salePriceEl) salePriceEl.textContent = this.formatMoneyWithoutTrailingZeros(variantPrice);
    } else {
      priceRoot.classList.remove('price--on-sale');
      if (regularPriceEl) regularPriceEl.textContent = this.formatMoneyWithoutTrailingZeros(variantPrice);
    }
  }

  formatMoneyWithoutTrailingZeros(money) {
    const formatted = this.formatMoney(money);
    return formatted.replace(/([.,])00(?=\D*$)/, '');
  }

  updateWidgetIfChanged(newData) {
    // Only update the widget if the value has changed from the previous data
    if (JSON.stringify(this.previousRetextionData) === JSON.stringify(newData))
      return;

    this.retextionData = { ...newData };

    this.updateTextContent(
        ".purchaseTypeLbl",
        this.retextionData.purchase_type_label,
        this.previousRetextionData.purchase_type_label
    );
    this.updateTextContent(
        ".one-time-purchase-label",
        this.retextionData.one_time_purchase_label,
        this.previousRetextionData.one_time_purchase_label
    );
    this.updateTextContent(
        ".subscription-label",
        this.retextionData.subscription_label,
        this.previousRetextionData.subscription_label
    );
    this.updateTextContent(
        ".icon-container",
        this.retextionData.icon_path,
        this.previousRetextionData.icon_path
    );
    this.updateTextContent(
        ".subscription-details-button-text",
        this.retextionData.subscription_details_box_button_text,
        this.previousRetextionData.subscription_details_box_button_text
    );
    this.updateTextContent(
        ".subscription-details-content",
        this.retextionData.subscription_details_box_content,
        this.previousRetextionData.subscription_details_box_content
    );
    this.updateTextContent(
        ".frequency-heading",
        this.retextionData.frequency_heading,
        this.previousRetextionData.frequency_heading
    );

    // Show or hide the subscription details box
    this.subscriptionDetailsBox.classList.toggle(
        "hidden",
        !this.retextionData.show_subscription_details
    );

    if (
        this.retextionData.default_to_subscription !==
        this.previousRetextionData.default_to_subscription
    ) {
      const isDefaultToSubscription =
          this.retextionData.default_to_subscription;
      const isSubscriptionSelected = this.isSubscriptionOptionSelected();

      if (isDefaultToSubscription !== isSubscriptionSelected) {
        this.purchaseTypeOneTime.classList.toggle(
            "is-selected",
            !isDefaultToSubscription
        );
        this.purchaseTypeSubscription.classList.toggle(
            "is-selected",
            isDefaultToSubscription
        );
        this.toggleRadioButtons();
      }
    }

    // Populate the frequency selector with selling plans if available
    const hasVariantChanged =
        this.retextionData.currentVariant &&
        this.previousRetextionData.currentVariant !==
        this.retextionData.currentVariant;

    const hasSellingPlans =
        this.retextionData.currentVariant?.selling_plan_allocations.length > 0;

    if (hasVariantChanged && hasSellingPlans) {
      this.subscriptionWidget.classList.toggle("is-visible", true);
      this.updateSellingPlans();
    } else {
      console.log("No SPs, hiding widget");
      this.subscriptionWidget.classList.toggle("is-visible", false);
      this.updateSellingPlanInput("");
    }

    this.updateExternalPrice(this.sellingPlanSelector?.value);

    //Update data
    this.previousRetextionData = { ...newData };
  }

  //Update content
  updateTextContent(selector, newValue, oldValue) {
    const element = this.shadowRoot.querySelector(selector);
    if (newValue !== oldValue && element) {
      element.innerHTML = newValue;
    }
  }

  // Set up event listeners for the purchase type, frequency and variant selectors
  setupEventListeners() {
    const purchaseTypeRadioButtons = this.shadowRoot.querySelectorAll(
        'input[name="purchaseType"]'
    );
    const variantSelectors = document.querySelectorAll('[name="id"]');

    // Handle purchase type change
    purchaseTypeRadioButtons.forEach((radio) =>
        radio.addEventListener("change", () => {
          this[
              radio.value === "purchaseTypeSubscription"
                  ? "showSubscriptionBox"
                  : "hideSubscriptionBox"
              ]();

          this.updateExternalPrice(this.sellingPlanSelector.value);
          this.updateProductPrice(this.sellingPlanSelector.value);
        })
    );

    // Handle frequency selector change
    this.sellingPlanSelector.addEventListener("change", (e) => {
      this.updateSelectedPlanValue(e.target.value);
      this.updateSellingPlanInput(e.target.value);
      this.updateProductPrice(e.target.value);
      this.updateExternalPrice(e.target.value);
    });

    // Handle variant change
    variantSelectors.forEach((selector) =>
        selector.addEventListener("change", ({ target }) => {
          const variantId = Number(target.value);
          this.retextionData.currentVariant =
              this.retextionData.product.variants.find((v) => v.id === variantId);
          this.updateWidgetIfChanged(this.retextionData);
        })
    );
  }

  // Populate the subscription frequency selector with selling plans for the current variant
  updateSellingPlans() {
    const { currentVariant, sellingPlanGroups } = this.retextionData;

    // Get the selling plans for the current variant
    const sellingPlans = currentVariant.selling_plan_allocations
        .map((spa) =>
            sellingPlanGroups
                .find((g) => g.id === spa.selling_plan_group_id)
                ?.selling_plans.find((sp) => sp.id === spa.selling_plan_id)
        )
        .filter(Boolean);

    // Clear existing options and populate dropdown
    this.sellingPlanSelector.innerHTML = sellingPlans
        .map(
            (plan) => `<option value="${plan.id}">${plan.options[0].value}</option>`
        )
        .join("");

    const hasSubscription = this.isSubscriptionOptionSelected();

    if (!hasSubscription) {
      this.addSelectFrequencyOption();
      this.updateSelectedPlanValue("");
      this.updateSellingPlanInput("");
    } else {
      this.updateSelectedPlanValue(this.sellingPlanSelector.value);
      this.updateSellingPlanInput(sellingPlans[0]?.id || "");
    }

    // Show or hide the subscription frequency selector
    this.subscriptionBox.classList.toggle("is-visible", hasSubscription);

    // Update prices
    this.updateProductPrice(
        hasSubscription
            ? this.sellingPlanSelector.value
            : sellingPlans[0]?.id || ""
    );

    this.updateExternalPrice(this.sellingPlanSelector.value);
  }

  addSelectFrequencyOption() {
    if (!this.sellingPlanSelector.querySelector('option[value=""]')) {
      this.sellingPlanSelector.insertAdjacentHTML(
          "afterbegin",
          '<option value="" selected>Select frequency</option>'
      );
    }
  }

  showSubscriptionBox() {
    this.subscriptionBox.classList.toggle("disable", false);
    this.subscriptionBox.classList.toggle("is-visible", true);
    this.purchaseTypeSubscription.classList.toggle("is-selected", true);
    this.purchaseTypeOneTime.classList.toggle("is-selected", false);

    // Remove "Select frequency" option
    this.sellingPlanSelector.querySelector('option[value=""]')?.remove();
    this.updateSelectedPlanValue(this.sellingPlanSelector.value);
    this.updateSellingPlanInput(this.sellingPlanSelector.value);
  }

  // Hide the subscription frequency selector
  hideSubscriptionBox() {
    if (!this.frequencyVisible) {
      this.subscriptionBox.classList.toggle("is-visible", false);
    }

    this.addSelectFrequencyOption();
    this.subscriptionBox.classList.toggle("disable", false);
    this.purchaseTypeSubscription.classList.toggle("is-selected", false);
    this.purchaseTypeOneTime.classList.toggle("is-selected", true);
    this.updateSelectedPlanValue("");
    this.updateSellingPlanInput("");
  }

  // Check if the subscription option is selected
  isSubscriptionOptionSelected() {
    return this.purchaseTypeSubscription.classList.contains("is-selected");
  }

  //Add selling plan input to form with specified selling plan ID
  updateSellingPlanInput(sellingPlanId) {
    const productForm = document.querySelector(
        this.retextionData.productFormId?.trim()
            ? `#${this.retextionData.productFormId}`
            : `form[action='/cart/add'][data-type='add-to-cart-form']`
    );

    if (!productForm) return;

    // Find or create the hidden input for selling plan
    let sellingPlanInput = productForm.querySelector(
        "input[name='selling_plan']"
    );
    if (!sellingPlanInput) {
      sellingPlanInput = document.createElement("input");
      sellingPlanInput.type = "hidden";
      sellingPlanInput.name = "selling_plan";
      sellingPlanInput.value = sellingPlanId;
      productForm.appendChild(sellingPlanInput);
    } else {
      sellingPlanInput.value = sellingPlanId;
    }
  }

  updateSelectedPlanValue(selectedValue) {
    if (!this.selectedPlanValueLabel) return;

    if (!this.sellingPlanSelector || selectedValue === "") {
      this.selectedPlanValueLabel.textContent = "";
      return;
    }

    const selectedOption =
        this.sellingPlanSelector.selectedOptions?.[0] ||
        this.sellingPlanSelector.querySelector(
            `option[value="${selectedValue}"]`
        );

    this.selectedPlanValueLabel.textContent =
        selectedOption?.textContent?.trim() || "";
  }

  updateProductPrice(sellingPlanId) {
    const { currentVariant, sellingPlanGroups } = this.retextionData;

    const selectedSellingPlanAllocation =
        currentVariant.selling_plan_allocations.find(
            (spa) => spa.selling_plan_id == sellingPlanId
        );

    const sellingPlan = sellingPlanGroups
        .find((group) => group.selling_plans.some((sp) => sp.id == sellingPlanId))
        ?.selling_plans.find((sp) => sp.id == sellingPlanId);

    const oneTimeLblPrice = this.shadowRoot.querySelector(
        "[data-rtx-onetime-price]"
    );
    const subscriptionLblPrice = this.shadowRoot.querySelector(
        "[data-rtx-subscription-price]"
    );
    const savingLbl = this.shadowRoot.querySelector(".subscription-savings");

    const onetimePrice = this.formatMoney(currentVariant.price);
    let subscriptionPrice = onetimePrice;

    // Update one-time price if necessary
    if (oneTimeLblPrice && oneTimeLblPrice.textContent !== onetimePrice) {
      oneTimeLblPrice.textContent = onetimePrice;
    }

    // Update subscription price
    if (selectedSellingPlanAllocation) {
      subscriptionPrice = this.formatMoney(selectedSellingPlanAllocation.price);

      if (
          subscriptionLblPrice &&
          subscriptionPrice !== subscriptionLblPrice.textContent
      ) {
        subscriptionLblPrice.innerHTML =
            subscriptionPrice !== onetimePrice
                ? `<s class="fullPrice">${onetimePrice}</s>${subscriptionPrice}`
                : subscriptionPrice;
      }

      // Calculate and update savings label
      let discount = currentVariant.price - selectedSellingPlanAllocation.price;

      if (discount > 0) {
        if (sellingPlan?.price_adjustments[0].value_type === "percentage") {
          discount = `${sellingPlan.price_adjustments[0].value}%`;
        } else {
          discount = this.formatMoney(discount);
        }
        if (savingLbl.textContent !== discount)
          savingLbl.textContent = `save ${discount}`;
      } else {
        savingLbl.textContent = "";
      }
    }
  }

  // Toggle checked state based on the currently checked radio button
  toggleRadioButtons() {
    this.radioOneTime.checked = !this.radioOneTime.checked;
    this.radioSubscription.checked = !this.radioSubscription.checked;
  }

  // Format money based on Shopify's active currency
  formatMoney(money) {
    const currencySymbols = {
      USD: "$",
      EUR: "€",
      GBP: "£",
      JPY: "¥",
      CAD: "C$",
      AUD: "A$",
      CHF: "CHF",
      CNY: "¥",
      SEK: "kr",
      NZD: "NZ$",
    };

    const activeCurrency = Shopify.currency.active;
    const currencySymbol = currencySymbols[activeCurrency] || activeCurrency;
    const formattedMoney = (money / 100).toFixed(2);
    var formatted;

    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        formatted = window.Shopify.formatMoney(money);
        if (formatted) return formatted;
      }

      if (
          window.theme &&
          window.theme.utils &&
          typeof window.theme.utils.formatMoney === "function"
      ) {
        formatted = theme.utils.formatMoney(money);
        if (formatted) return formatted;
      }
      return `${currencySymbol}${formattedMoney}`;
    } catch (error) {
      console.error("Error formatting money:", error);
      return `${currencySymbols["USD"]}${formattedMoney}`;
    }
  }

  // Apply styles to the widget
  applyStyles(settings) {
    const style = document.createElement("style");

    //Widget layout
    let layoutCSS = "";
    if (settings.widget_layout === "stacked-buttons") {
      layoutCSS = `.rtx-purchase-label input{
          display: none!important;
        }`;
    } else if (settings.widget_layout === "side-by-side-buttons") {
      layoutCSS = `.widget{
                    align-items: center;
                    flex-direction: row;
                    gap:10px;
                }
                .purchase-label{
                    flex-direction: column;
                    align-items: center;
                }
                .rtx-purchase-label input{
                  display: none!important;
                }
                .rtx-purchase-label__inner{
                  margin-bottom: 0px;
                }
                `;
    }

    style.textContent = `
      :host {
        --text-color: ${settings.textColor};
        --font-family: ${settings.fontFamily};
        --font-size: ${settings.fontSize};
        --border-radius: ${settings.borderRadius};
        --border-width: ${settings.borderWidth};
        --border-color: ${settings.borderColor};
        --selected-text-color: ${settings.selectedTextColor};
        --bg-color: ${settings.bgColor};
        --selected-bg-color: ${settings.selectedBgColor};
        --accent-color: ${settings.accentColor};
      }
        .stay-ai-subscriptions {
            display: none;
        }
        .stay-ai-subscriptions.is-visible {
            display: block;
            border-radius: 24px;
            padding: 16px 24px;
            background: #FFFFFF;
            margin: 0 0 16px
        }
        
        .purchaseTypeLbl, .frequency-heading{
            font-family: 'HeeboRegular', sans-serif;
            color: var(--text-color)!important;
            text-transform: uppercase;
            font-weight: 700;
            font-size:14px;
        }
        
        .rtx-subscription,.rtx-subcription * {
            box-sizing: border-box;
            color: var(--text-color)!important;
            font-family: 'HeeboRegular', sans-serif!important;
            font-size: var(--font-size)!important;
        }
        
        .rtx-subscription {
          display: flex;
          flex-direction: column;
          grid-row-gap: 10px;
        }
        
        .widget{
          display: flex;
          flex-direction: column;
          grid-row-gap: 21px;
        }
        
        .widget label:nth-child(2):before {
          content: '';
          position: absolute;
          width: 100%;
          top: -10px;
          left: 0;
          right: 0;
          height: 1px;
          background: #E3E3DE;
        }
        
        .one-time-purchase-label,
        .subscription-label {
          font-family: 'HeeboRegular', sans-serif;
          line-height: 1.2;
          font-size: 20px;
          color: #000000;
          margin: 0;
        }
        
        /* Widget layout */
        ${layoutCSS}
        
        /* Purchase labels */
        .rtx-subscription label{
          width: 100%;
          cursor: pointer;
          position: relative;
          padding: 8px 0;
          display: block
        }
        
        .rtx-subscription label.purchaseTypeSubscription {
          padding-top: 0;
          transition: all .3s ease-in-out
        }
        
        .rtx-subscription label.purchaseTypeOneTime {
          padding-bottom: 0;
          transition: all .3s ease-in-out
        }
        
        .rtx-subscription label.purchaseTypeSubscription:not(.is-selected),
        .rtx-subscription label.purchaseTypeOneTime:not(.is-selected) {
          opacity: .5;
        }
        
        .purchase-label {
          display: flex;
          justify-content: space-between;
          background-color: #ffffff;
        }
        
        .rtx-purchase-label__inner {
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            grid-column-gap: 10px;
            grid-row-gap: 10px;
            flex-grow: 0.6;
        }
        
        .rtx-purchase-label__inner .wrap {
          display: flex;
          grid-column-gap: 8px;
          align-items: center;
        }    
        
        .rtx-purchase-label .input-wrap {
          position: relative;
        }
        
        .rtx-purchase-label input {
          position: absolute;
          top: 0; 
          width: 0;
          height: 0;
        }
        
        .rtx-purchase-label input:checked ~ .input-radio {
          background: #03FF00;
          border-color: #E1FBDB;
        }
        
        .rtx-purchase-label .input-radio {
          display:flex;
          width: 16px;
          height: 16px;
          min-width: 16px;
          cursor: pointer;
          border-radius: 100%;
          background: #E3E3DE;
          border: 1px solid #B8B8B2;
          transition: all .3s ease-in-out;
          box-sizing: border-box;
        }
        
        .subscription-savings,
        .subscription-custom-label {
          padding: 4px 9px;
          border-radius: 40px;
          
          font-family: 'HeeboRegular', sans-serif;
          text-transform: uppercase;
          font-weight: normal;
          font-size: 12px;
          line-height: 1;
        }
        
        .subscription-custom-label.mobile {
          display: none;
          margin-top:8px;
        }
        
        .subscription-custom-label {
          background: #E1FBDB;
        }
        
        .subscription-savings {
          background: #E6FF2E;
        }

        label.is-selected [data-rtx-subscription-price=''], label.is-selected [data-rtx-onetime-price='']{
            color: var(--selected-text-color);
        }
        
        [data-rtx-subscription-price=''] {
          gap: 8px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-end;
        }
        
        [data-rtx-subscription-price=''],
        [data-rtx-onetime-price] {
          font-family: 'HeeboRegular', sans-serif;
          font-weight: normal;
          color: #000000;
          font-size: 20px;
          line-height: 1.2;
        }
        
        [data-rtx-subscription-price=''] s{
          color: #B8B8B2;
          font-size: 16px;
          line-height: 1.5;
        }

        /* Display compare at price */
        ${settings.display_compare_at_price ? "": "[data-rtx-subscription-price=''] s{display:none;}"}

        /* Display compare at price position */
        ${settings.compare_at_price_first ? "" : "[data-rtx-subscription-price='']{flex-direction: row-reverse;}[data-rtx-subscription-price='']{justify-content: flex-start;}"}

        /* Subscription box that displays the frequency selector */
        ${settings.frequencyVisible ? "" : ".rtx-subscription-box{display:none}"}
        
        .rtx-subscription-box.is-visible {
          display: flex;
          flex-wrap: wrap;
          grid-row-gap: 5px;
          align-items: center;
          grid-column-gap: 5px;
        }  
        
        /*select[name='rtx_selling_plan']{
          font-family: 'HeeboRegular', sans-serif;
          padding: 5px 20px;
          appearance: auto;
          cursor: pointer;
        }*/
        
        .hidden {
          display: none;
        }    

        .custom-select-wrap {
          margin-top: 8px;
          width: 100%;
          display: flex;
          align-items: center;
          grid-column-gap: 10px;
        }
        
        .custom-select-txt {
          font-family: 'HeeboRegular', sans-serif;
          font-style: normal;
          font-size: 16px;
          line-height: 1.5;
          color: #000000;
          display: block;
          white-space: nowrap;
        }
        
        .custom-select-txt .select-value {
          display: none;
        }
        
        .custom-select {
          width: 100%;
          position: relative;
        }
        
        .rtx-subscription-dropdown {
          width: 100%;
          height: 37px;
          padding: 8px 48px 8px 16px;
        
          font-family: 'HeeboRegular', sans-serif;
          line-height: 1.5;
          font-size: 14px;
          color: #000000;
        
          border-radius: 10px;
          background-color: #ffffff;
          border: 1px solid #B8B8B2;
        
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
        
          cursor: pointer;
          outline: none;
        }
        
        .rtx-subscription-dropdown:hover {
          border-color: #999;
        }
        
        .rtx-subscription-dropdown:focus {
          border-color: #333;
        }
        
        .custom-select::after {
          content: "";
          position: absolute;
          top: 45%;
          right: 18px;
          width: 8px;
          height: 8px;
          pointer-events: none;
          border-right: 2px solid #B8B8B2;
          border-bottom: 2px solid #B8B8B2;
          transform: translateY(-50%) rotate(45deg);
        }
        
        .rtx-modal-button {
            padding: 0;
            font-size: 16px;
            background: none;
            border: none;
            text-transform: initial;
            height: auto;
            min-height: 0;
            margin-left: 0px;
            cursor: pointer;
            margin-top: 10px;
            color: var(--text_color);
            font-family: 'HeeboRegular', sans-serif !important;
            font-size: var(--font-size) !important;
        }

        /* Modal content */
        .rtx-modal__content {
            position: absolute;
            z-index: 5;
            background: white;
            width: auto;
            max-width: 25rem;
            overflow-x: hidden;
            padding: 1rem 2rem;
            font-size: 15px;
            transform: translateY(-1rem);
            margin-top: 5px;
            margin-left: 12px;
            display: none;
            opacity: 0;
            transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
            box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.12),
                        0px 1px 2px 0px rgba(0, 0, 0, 0.24);
        }

        /* Modal container */
        .rtx-modal {
            z-index: 5;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
        }

        /* Hover effect for button and showing modal content */
        .rtx-modal-button:hover ~ .rtx-modal {
            opacity: 1;
            visibility: visible;
            transition: opacity 0.3s ease-out, visibility 0.3s ease-out;
        }

        .rtx-modal-button:hover + .rtx-modal .rtx-modal__content {
            display: block;
            opacity: 1;
            transform: translateY(0);
        }
        .disable{
          pointer-events: none;
          cursor: none;
          opacity: 0.5;
        }
        
        @media (max-width: 767px) {
          .stay-ai-subscriptions.is-visible {
            padding: 20px 14px
          }
          
          .rtx-purchase-label__inner {
            gap: 8px;
          }
          
          .widget {
            grid-row-gap: 17px;
          }
          
          .widget label:nth-child(2):before {
            top: -9px;
          }
          
          .one-time-purchase-label, 
          .subscription-label {
            font-size: 16px;
            line-height: 22px;
          }
          
          .subscription-custom-label.desktop {
            display:none;
          }
          
          .subscription-custom-label.mobile {
            display: block;
            text-align: center;
          }
          
          [data-rtx-subscription-price=''],
          [data-rtx-onetime-price] {
            font-size: 16px;
            line-height: 22px;
          }
          
          [data-rtx-subscription-price=''] s {
            font-size: 12px;
          }
          
          .custom-select-txt .select-value {
            display: inline-block;
          }
        }
        
        @media (max-width: 600px) {
         .widget {   
           flex-direction: column;
         }
         
         .rtx-modal__content {
            max-width: 90%;
            padding: 1rem;
            font-size: 16px;
          }
        }
    `;

    // Append the style element to the shadow root
    this.shadowRoot.appendChild(style);
  }
}

// Define the custom element
customElements.define("purchase-options", StayAISubscriptions);